import Vue from "vue"
import { isOverflow } from "@/utils/ui"
import _ from "lodash"

Vue.directive("tip", function(el, binding) {
  const { value } = binding
  if (value === false) {
    el.classList.remove("tip-wrap")
    el._tip_listener?.mouseenter &&
      el.removeEventListener("mouseenter", el._tip_listener.mouseenter)
    el._tip_listener?.mouseleave &&
      el.removeEventListener("mouseleave", el._tip_listener.mouseleave)
  } else {
    if (_.isNumber(value)) {
      el.style["display"] = "-webkit-box"
      el.style["-webkit-box-orient"] = "vertical"
      el.style["-webkit-line-clamp"] = value
      el.style["overflow"] = "hidden"
      el.style["whiteSpace"] = "unset"
    }

    if (_.isEmpty(el._tip_listener)) {
      el._tip_listener = {
        mouseenter() {
          if (isOverflow(el)) {
            window.showTip(el, el.innerText || el.textContent)
          }
        },
        mouseleave() {
          window.hideTip()
        }
      }
    }
    el.classList.add("tip-wrap")
    el.addEventListener("mouseenter", el._tip_listener.mouseenter)
    el.addEventListener("mouseleave", el._tip_listener.mouseleave)
  }
})
